import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
import { LandingsData } from 'sections/Resources/FreightDictionary/data';
import styles from 'pages/freight-dictionary/FreightDictionary.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightDictionary/components/SectionHeader'));
const SectionTerms = dynamic(() => import('sections/Resources/FreightDictionary/components/SectionTerms'));

export default function FreightDictionary() {
  return (
    <div className={cn('freight-dictionary')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mode="light"
          mTop={64}
          links={[{ title: 'Freight Dictionary', href: '' as Route }]}
        />
      </div>
      <SectionHeader />
      <SectionTerms />
    </div>
  );
}

export const getStaticProps = async () => {
  const pageProps: any = {
    title: 'Freight Dictionary | Logistics & Shipping Terms | DF Alliance',
    description:
      'Learn & understand freight shipping terms used in the industry to boost your supply chain terminology. Get a detailed explanation of all freight shipping terms.',
    keywords: 'Freight dictionary, freight terms, shipping terms',
    path: '/freight-dictionary',
    landingsData: LandingsData,
  }

  return {
    props: {
      ...pageProps,
    }
  }
};

FreightDictionary.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
